import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

export default function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);
  const [needSetup, setNeedSetup] = useState(false);

  useEffect(() => {
    api.get("/setup/status").then(r => setNeedSetup(!r.data.users_exist && r.data.setup_enabled)).catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setErr(null); setBusy(true);
    try {
      const r = await login(email, password);
      nav(r.must_change_password ? "/change-password" : "/");
    } catch (ex) {
      setErr(ex?.response?.data?.detail || "Errore di accesso");
    }
    setBusy(false);
  };

  return (
    <div className="ma-auth-wrap">
      <div className="ma-auth-card">
        <div className="ma-brand-lg" data-testid="login-brand">MASI<span>ADVICE</span></div>
        <div className="ma-brand-sub">CRM · Accesso riservato</div>
        <form onSubmit={submit} className="ma-form">
          <label className="ma-label">Email</label>
          <input type="email" className="ma-input" value={email} onChange={e=>setEmail(e.target.value)}
                 required data-testid="login-email" autoComplete="username" />
          <label className="ma-label">Password</label>
          <input type="password" className="ma-input" value={password} onChange={e=>setPassword(e.target.value)}
                 required data-testid="login-password" autoComplete="current-password" />
          {err && <div className="ma-error" data-testid="login-error">{err}</div>}
          <button className="ma-btn-primary" disabled={busy} data-testid="login-submit">
            {busy ? "Accesso…" : "Accedi"}
          </button>
        </form>
        {needSetup && (
          <div className="ma-auth-note" data-testid="setup-hint">
            Prima configurazione? <Link to="/setup">Crea l'amministratore</Link>
          </div>
        )}
      </div>
      <div className="ma-auth-foot">© MasiAdvice · Uso interno</div>
    </div>
  );
}
